import { useQuery } from '@tanstack/react-query'

import { getOrganizationChartRoles } from '@src/api'
import { DefaultApiGetOrganizationChartRolesRequest } from '@src/api/generated/user-api'
import { REACT_QUERY_CACHE_KEYS } from '@src/consts'
import { useAxios } from '@src/hooks'

export const useFetchOrganizationChartRoles = (
  params: DefaultApiGetOrganizationChartRolesRequest
) => {
  const { axiosInstance } = useAxios()
  const { data, isError, isLoading, refetch } = useQuery({
    enabled: !!params.organizationId,
    queryFn: () => getOrganizationChartRoles(axiosInstance, params),
    queryKey: [REACT_QUERY_CACHE_KEYS.GET_ORGANIZATION_CHART_ROLES],
  })

  return { data, isError, isLoading, refetch }
}
